import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { Fragment, type ReactNode } from 'react'

export interface PageHeroStat {
  label: string
  value: string
  icon?: ReactNode
  hidden?: boolean
}

interface PageHeroStatsProps {
  stats: PageHeroStat[]
  loading: boolean
}

export function PageHeroStats({ stats, loading }: PageHeroStatsProps) {
  const visibleStats = stats.filter((s) => !s.hidden)
  if (visibleStats.length === 0) return null

  return (
    <div className="flex items-center gap-3 sm:gap-5">
      {visibleStats.map((stat, i) => (
        <Fragment key={stat.label}>
          {i > 0 && <div className="h-8 w-px bg-white/10 sm:h-10" />}
          <div className="flex flex-col items-start md:items-end">
            {stat.icon ? (
              <div className="flex items-center gap-1">
                {stat.icon}
                <span className="text-xs text-muted-foreground sm:text-sm">{stat.label}</span>
              </div>
            ) : (
              <span className="text-xs text-muted-foreground sm:text-sm">{stat.label}</span>
            )}
            {loading ? (
              <Skeleton className="mt-0.5 h-4 w-12 sm:mt-1 sm:h-5 sm:w-20" />
            ) : (
              <span className="bg-gradient-to-r from-gradient-yellow to-gradient-green bg-clip-text font-semibold text-sm text-transparent sm:font-bold sm:text-lg">
                {stat.value}
              </span>
            )}
          </div>
        </Fragment>
      ))}
    </div>
  )
}
